import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=495786fa&scoped=true&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=495786fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495786fa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495786fa')) {
      api.createRecord('495786fa', component.options)
    } else {
      api.reload('495786fa', component.options)
    }
    module.hot.accept("./OrganizationInfo.vue?vue&type=template&id=495786fa&scoped=true&", function () {
      api.rerender('495786fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/tabs/OrganizationInfo.vue"
export default component.exports